<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [style]="{width: '800px', height: '700px'}"
  styleClass="p-fluid comunica-contributo-dialog"
  [showHeader]="false"
  (onHide)="hide()">

  <div class="dialog-container">
    <div class="dialog-header">
      <div class="header-content">
        <i class="pi pi-file-check header-icon"></i>
        <h2>Inserimento Determina</h2>
      </div>
      <button
        pButton
        pRipple
        icon="pi pi-times"
        class="p-button-rounded p-button-text close-btn"
        (click)="hide()">
      </button>
    </div>

    <div class="dialog-content">
      <div class="field">
        <label for="numeroDetermina">Numero Determina</label>
        <input
          id="numeroDetermina"
          type="text"
          pInputText
          [(ngModel)]="numeroDetermina"
          placeholder="Inserisci il numero della determina"
          required />
      </div>

      <div class="field">
        <label for="note">Note</label>
        <textarea
          id="note"
          pInputTextarea
          [(ngModel)]="note"
          [rows]="3"
          placeholder="Inserisci eventuali note"
          style="width: 100%"></textarea>
      </div>

      <div class="field">
        <label for="fileDetermina">Allega uno o più file</label>
        <p-fileUpload
          id="fileDetermina"
          mode="advanced"
          name="fileDetermina"
          accept=".p7m"
          [maxFileSize]="10000000"
          chooseLabel="Seleziona File"
          (onSelect)="onFileSelect($event)"
          [auto]="true"
          styleClass="p-button-outlined"
          [multiple]="true">
        </p-fileUpload>
        <!-- <div *ngIf="fileDetermina" class="file-info" style="margin-top: 0.5rem; display: flex; align-items: center; gap: 0.5rem;">
          <i class="pi pi-file" style="color: #4f97c4;"></i>
          <span style="font-size: 0.9rem;">{{fileDetermina.name}}</span>
          <button
            pButton
            pRipple
            icon="pi pi-times"
            class="p-button-rounded p-button-text p-button-danger"
            (click)="fileDetermina = null"
            style="margin-left: auto;">
          </button>
        </div> -->
      </div>
    </div>

    <div class="dialog-footer" style="display: flex; justify-content: flex-end; gap: 0.5rem; width: 50%; margin-left: auto; margin-top: 2rem; margin-bottom: 1rem; padding-right: 1rem;">
      <button
        pButton
        pRipple
        label="Annulla"
        icon="pi pi-times"
        class="p-button-outlined p-button-secondary"
        (click)="hide()">
      </button>
      <button
        pButton
        pRipple
        label="Salva"
        icon="pi pi-check"
        class="p-button-success"
        (click)="salvaDetermina()"
        [disabled]="!isFormValid()">
      </button>
    </div>
  </div>
</p-dialog>

<p-toast position="top-right"></p-toast>
